import React from "react";
import "../assets/css/style.css";
import img from "../assets/css/img/why.png";
import shock from '../assets/css/img/shock2.png';

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us container-fluid my-5">
      <div className="row align-items-center">
        <h1 className=" white-heading text-center mb-4">
          <img src={shock} className="shock2" alt="shock-icon" />&nbsp; Why Choose Us
        </h1>
        <div className="col-md-6  "> {/* Center image in column */}

          <div className="image-container ">
            <img
              src={img}
              alt="Solar Panels"
              className="img-fluid rounded shadow-lg"
            // Ensure image scales within column
            />
          </div>
        </div>
        <div className="col-md-6">
          <h4 >
            Complete Commercial &<br /> Residential Solar Systems
          </h4>
          <p className="why-description">
            Solar energy provides a good return on investment through the use of<br />
            un-utilized rooftop space and requires minimal maintenance.
          </p>
          <ul className="why-list">
            <li><strong>Trusted Partnership –</strong> We are an
              Authorized Channel Partner of Tata
              Power Solar, India’s No.1 solar company,
              ensuring top-tier products and service.</li>
            <li><strong>
              MNRE Compliance –</strong> As an official
              MNRE vendor, we strictly adhere to all
              Ministry of New and Renewable Energy
              policies and standards for high-quality
              and compliant installations.</li>
            <li><strong>
              Sustainable Energy Solutions –</strong> Our
              solar solutions not only lower your
              energy bills but also contribute to India’s
              journey towards energy independence
              and a greener future.</li>
            <li><strong>End-to-End Expertise –</strong>From
              consultation to installation and
              maintenance, we provide comprehensive
              solar solutions tailored to residential,
              commercial, and industrial needs</li>
            <li><strong>Property Value Enhancement –</strong>
              Our
              reliable and sustainable installations add
              lasting value to your property, making it
              more energy-efficient and attractive.</li>
            <li><strong>
              Customer-Centric Service –</strong> We
              prioritize your satisfaction with prompt,
              personalized support and a commitment
              to delivering excellence at every step.</li>
            <li>
              <strong>Commitment to Clean Energy –</strong> By choosing Axis Solar Systems, you’re
              supporting India’s mission to reduce
              carbon emissions and create a sustainable tomorrow </li>
          </ul>
          {/* <button className="btn review-button">Know More</button> */}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
